module.exports = __webpack_public_path__ + "static/card-img-3-47cb53497134a29bd1c1bc76d0853422.jpg";